import React from 'react'
import PropTypes from 'prop-types'

import MaleDailyArticlesShimmer from 'Containers/male_daily/articles/shimmer'
import MaleDailyBannerShimmer from 'Containers/male_daily/banner/shimmer'
import MaleDailyVideoShimmer from 'Containers/male_daily/video/shimmer'

const MaleDailyContentShimmer = ({ isMobile }) => {
  return (
    <>
      <MaleDailyBannerShimmer isMobile={isMobile} />

      <div style={{ height: isMobile ? '20px' : '80px' }} />

      <MaleDailyArticlesShimmer isMobile={isMobile} />

      <div style={{ height: isMobile ? '32px' : '80px' }} />

      <MaleDailyVideoShimmer isMobile={isMobile} />

      <div style={{ height: '80px' }} />
    </>
  )
}

MaleDailyContentShimmer.propTypes = {
  isMobile: PropTypes.bool,
}

export default MaleDailyContentShimmer
